// extracted by mini-css-extract-plugin
module.exports = {"collaborationWrapper":"style_collaborationWrapper__1atHk","collaborationDouble":"style_collaborationDouble__KXuP5","collaborationimage":"style_collaborationimage__Y4c5y"};